// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3CFvS","label":"Radio_label__2eKYj","checkMark":"Radio_checkMark__2Zx8i","disabled":"Radio_disabled__1aDRu"};